/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    asset: "TÀI SẢN",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "100",
    asset: "A - TÀI SẢN NGẮN HẠN (100=110+120+130+140+150)",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "110",
    sttBold: true,
    asset: "I. Tiền và các khoản tương đương tiền",
    assetBold: true,
    presentReadOnly: false,
    readOnly: false,
    presentBold: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "120",
    sttBold: true,
    asset: "II. Đầu tư tài chính",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "121",
    sttBold: false,
    asset: "1. Chứng khoán kinh doanh",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "122",
    sttBold: false,
    asset: "2. Đầu tư nắm giữ đến ngày đáo hạn",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "123",
    sttBold: false,
    asset: "3. Đầu tư góp vốn vào đơn vị khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "130",
    sttBold: true,
    asset: "III. Các khoản phải thu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "131",
    sttBold: false,
    asset: "1. Phải thu của khách hàng",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "132",
    sttBold: false,
    asset: "2. Trả trước cho người bán",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "133",
    sttBold: false,
    asset: "3. Vốn kinh doanh ở đơn vị trực thuộc",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "134",
    sttBold: false,
    asset: "4. Phải thu khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "135",
    sttBold: false,
    asset: "5. Tài sản thiếu chờ xử lý",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "140",
    sttBold: true,
    asset: "IV. Hàng tồn kho",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "150",
    sttBold: true,
    asset: "V. Tài sản cố định và bất động sản đầu tư",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "160",
    sttBold: true,
    asset: "VI. Xây dựng cơ bản dở dang",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "170",
    sttBold: true,
    asset: "VII. Tài sản khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "171",
    sttBold: false,
    asset: "1. Thuế GTGT được khấu trừ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "172",
    sttBold: false,
    asset: "2. Tài sản khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "200",
    sttBold: true,
    asset: "TỔNG CỘNG TÀI SẢN (200=110+120+130+140+150+160+170)",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "",
    sttBold: true,
    asset: "NGUỒN VỐN",
    assetBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 21,
    stt: "300",
    sttBold: true,
    asset: "I. Nợ phải trả",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "311",
    sttBold: false,
    asset: "1. Phải trả người bán",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "312",
    sttBold: false,
    asset: "2. Người mua trả tiền trước",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "313",
    sttBold: false,
    asset: "3. Thuế và các khoản phải nộp Nhà nước",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "314",
    sttBold: false,
    asset: "4. Phải trả người lao động",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "315",
    sttBold: false,
    asset: "5. Phải trả khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "316",
    sttBold: false,
    asset: "6. Vay và nợ thuê tài chính",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "317",
    sttBold: false,
    asset: "7. Phải trả nội bộ về vốn kinh doanh",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "318",
    sttBold: false,
    asset: "8. Dự phòng phải trả",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "319",
    sttBold: false,
    asset: "9. Quỹ khen thưởng, phúc lợi",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "320",
    sttBold: false,
    asset: "10. Quỹ phát triển khoa học và công nghệ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "400",
    sttBold: true,
    asset: "II. Vốn chủ sở hữu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "411",
    sttBold: false,
    asset: "1. Vốn góp của chủ sở hữu",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "412",
    sttBold: false,
    asset: "2. Thặng dư vốn cổ phần",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "413",
    sttBold: false,
    asset: "3. Vốn khác của chủ sở hữu ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "414",
    sttBold: false,
    asset: "4. Cổ phiếu quỹ (*) ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "415",
    sttBold: false,
    asset: "5. Chênh lệch tỷ giá hối đoái",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "416",
    sttBold: false,
    asset: "6. Các quỹ thuộc vốn chủ sở hữu",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "417",
    sttBold: false,
    asset: "7. Lợi nhuận sau thuế chưa phân phối",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "500",
    sttBold: true,
    asset: "TỔNG CỘNG NGUỒN VỐN (500=300+400)",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic" fontWeight="bold">
          Đơn vị tính: triệu đồng VN
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối quý</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
              <Th style={{ textAlign: "center" }}>5</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="now"
                      readOnly={rows.readOnly}
                      value={rows.value.now}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="before"
                      readOnly={rows.readOnly}
                      value={rows.value.before}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
